import { css, cx } from '@emotion/css';
import { scrollableAncestor } from 'Shared/frontend/scrollableAncestor';
import { onCleanup, onMount } from 'solid-js';


const parallaxStyle = () => css({
	/* overflowY doesn't appear to work with position:static */
	position: 'relative',
	overflowY: 'hidden',
	marginBottom: -1,
});

const backgroundStyle = () => css({
	position: 'absolute',
	top: 0,
	width: '100%',
	height: '100%',
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	willChange: 'transform'
});

const bannerStyle = () => css({
	width: '100%',
	height: '100vh',
	minHeight: 500
});



function adjustBackground(backgroundNode:HTMLDivElement,scrollRate:number)
{
	const back = backgroundNode.getBoundingClientRect();

	/* Use this value if it scrolled off the top */
	let offset = '-100%';

	if (window.innerHeight > back.top)
	{
		/* Add extra height to the background image when images < 100vh */
		const extraHeight = (window.innerHeight - back.height) * scrollRate;
		if (extraHeight>=1) {
			const newHeight = back.height + extraHeight;
			backgroundNode.style.height = newHeight+'px';
		}

		/* Reduce the scroll of the background: */
		const fractionUpPage = back.top / back.height; 
		offset = (-fractionUpPage * window.innerHeight * scrollRate) + 'px';
	}

	backgroundNode.style.transform = 'translateY('+offset+')';
}


//TODO remove the other Parallax widget now if possible...

export function Parallax(P:{scrollRate:number,children})
{
	let backgroundNode!: HTMLDivElement;

//TODO maybe enable/disable using Intersection Observer	

	onMount(() => {
		/* In a preview pane the scroll container is a div rather than window.
		   Listen to both: in 2-column mode only the pane fires; in narrow mode only window fires. */
		const ancestor = scrollableAncestor(backgroundNode);

		const handler = () => window.requestAnimationFrame(() => adjustBackground(backgroundNode,P.scrollRate));
		window.addEventListener('scroll',handler);
		window.addEventListener('resize',handler);
		ancestor?.addEventListener('scroll',handler);

		onCleanup(() => {
			window.removeEventListener('scroll',handler);
			window.removeEventListener('resize',handler);
			ancestor?.removeEventListener('scroll',handler);
		});

		adjustBackground(backgroundNode,P.scrollRate);
	});

	return (
		<div class={cx(bannerStyle(),parallaxStyle())}>
			<div ref={backgroundNode} class={backgroundStyle()} >
				{P.children}
			</div>
		</div>
	);
}

